'use client';

import type { LotteryOptionGoodsForm } from '../../types';
import styles from './OptionNamedBar.module.scss';

export type OptionNamedBarProps = {
  optionFormData?: LotteryOptionGoodsForm;
  filledInputCount: number;
  hasInvalidInput: boolean;
  onGoBack: () => void;
  onSubmit: () => void;
};

function OptionNamedBar({
  optionFormData,
  filledInputCount,
  hasInvalidInput,
  onGoBack,
  onSubmit,
}: OptionNamedBarProps) {
  // 入力完了ボタンのボタン色を取得
  const getConfirmButtonColor = (
    currentOptionFormData: LotteryOptionGoodsForm | undefined,
    currentFilledInputCount: number,
  ): 'gray' | 'primary' => {
    if (!currentOptionFormData) return 'gray';
    if (hasInvalidInput) return 'gray';
    const remainingCount = Math.max(0, currentOptionFormData.totalAcquiredCount - currentFilledInputCount);
    return remainingCount > 0 ? 'gray' : 'primary';
  };

  // 入力完了ボタンを無効にするかどうかの判定
  const isConfirmButtonDisabled = (
    currentOptionFormData: LotteryOptionGoodsForm | undefined,
    currentFilledInputCount: number,
  ): boolean => {
    if (!currentOptionFormData) return true;
    // 使えない文字が入ったまま送信すると API で弾かれるため、入力欄の赤い文字のエラーが消えるまで押せないようにする
    if (hasInvalidInput) return true;
    const remainingCount = Math.max(0, currentOptionFormData.totalAcquiredCount - currentFilledInputCount);
    return remainingCount > 0;
  };

  // 残りの入力が必要な数を取得
  const getRemainingCount = (): number => {
    if (!optionFormData) return 0;
    return Math.max(0, optionFormData.totalAcquiredCount - filledInputCount);
  };

  const confirmButtonColor = getConfirmButtonColor(optionFormData, filledInputCount);
  const confirmButtonDisabled = isConfirmButtonDisabled(optionFormData, filledInputCount);
  const remainingCount = getRemainingCount();

  return (
    <div className={styles.componentStyle}>
      <div className={styles.container}>
        <div className={styles.statusText}>
          <p className={styles.remainingText}>残り{remainingCount}個の入力が必要です</p>
          <p className={styles.selectedText}>{filledInputCount}個 入力済み</p>
        </div>
        <div className={styles.buttonWrapper}>
          <button type='button' className={styles.backButton} onClick={onGoBack}>
            戻る
          </button>
          <div className={styles.confirmButtonWrapper}>
            <button
              type='button'
              className={styles.confirmButton}
              onClick={onSubmit}
              color={confirmButtonColor}
              disabled={confirmButtonDisabled}
            >
              入力を完了する
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OptionNamedBar;
